<mat-form-field class="custom-autocomplete">
    <input
        matInput
        #input
        type="text"
        autocomplete="off"
        tabindex="-1"
        [placeholder]="asFormsControl().placeholder"
        [matAutocomplete]="autoComplete"
        [disabled]="asFormsControl().disabled"

        (input)="filterOptions($event)"
        (paste)="filterOptionsOnPaste($event)"
        (click)="updateAutocompletePosition()"
        (focus)="updateAutocompletePosition()"
    >
    <i class="fa fa-caret-down"></i>
    <mat-autocomplete
        #autoComplete="matAutocomplete"
        (optionSelected)="selectOption($event)"
        (opened)="onTouched && onTouched()"
    >
        <ng-container *ngIf="!asFormsControl().grouped; else groupedOptions">
            <mat-option
                *ngFor="let option of autocompleteOptions | async; trackBy: trackById"
                [value]="option.value">
                <div class="select-item" [ngClass]="{'select-item-with-icon': option.classes}">
                    <span [ngClass]="option.classes"></span>
                    <span> {{option.label}}</span>
                </div>
            </mat-option>
        </ng-container>
        <ng-template #groupedOptions>
            <mat-optgroup *ngFor="let group of autocompleteGroups | async" [label]="group.options.name">
                <mat-option *ngFor="let item of group.options.items; trackBy: trackById" [value]="item.value">
                    <div class="select-item" [ngClass]="{'select-item-with-icon': item.classes}">
                        <span [ngClass]="item.classes"></span>
                        <span> {{item.label}}</span>
                    </div>
                </mat-option>
            </mat-optgroup>
        </ng-template>
    </mat-autocomplete>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

